import { useState } from 'react'
import { Link, useSearchParams } from 'react-router'
import { useResetPassword } from '../hooks/useAuth'

export function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const linkError = params.get('error')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [mismatch, setMismatch] = useState(false)
  const resetPassword = useResetPassword()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (password !== confirm) {
      setMismatch(true)
      return
    }
    setMismatch(false)
    resetPassword.mutate({ token, newPassword: password })
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="sidebar-brand-icon">×</div>
          <h1>
            double<span style={{ color: 'var(--accent-primary)' }}>·</span>xl
          </h1>
          <p className="text-muted">Studio OS</p>
        </div>

        {!token ? (
          <div className="login-form">
            <p className="form-error">
              {linkError
                ? 'This reset link is invalid or has expired. Request a new one below.'
                : 'This reset link is missing its token. Request a new one below.'}
            </p>
            <Link to="/forgot-password" className="btn btn-primary btn-full">
              Request a new link
            </Link>
          </div>
        ) : resetPassword.isSuccess ? (
          <div className="login-form">
            <p>Your password has been reset.</p>
            <Link to="/" className="btn btn-primary btn-full">
              Sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-field">
              <label htmlFor="password">New password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>
            <div className="form-field">
              <label htmlFor="confirm">Confirm new password</label>
              <input
                id="confirm"
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="••••••••"
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>

            {mismatch && <p className="form-error">Passwords do not match.</p>}
            {resetPassword.error && (
              <p className="form-error">
                {(resetPassword.error as any)?.body?.error?.message ||
                  'Reset failed — the link may have expired. Request a new one.'}
              </p>
            )}

            <button
              type="submit"
              className="btn btn-primary btn-full"
              disabled={resetPassword.isPending}
            >
              {resetPassword.isPending ? 'Resetting...' : 'Reset password'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
